import { LoaderCircle } from "lucide-react";
import { cn } from "../../lib/utils.js";

/** Animated in-progress loader shared by the Results "Processing" chip and Campaign RUNNING status. */
export function CampaignProcessingIcon({
  size = 12,
  className,
}: {
  size?: number;
  className?: string;
}): React.JSX.Element {
  return (
    <LoaderCircle
      size={size}
      className={cn("animate-spin motion-reduce:animate-none", className)}
      aria-hidden="true"
    />
  );
}
